// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import UsercustomerService from "../Masters/Usercustomers/UsercustomerService.js";
// import SettingsServices from "../Settings/SettingsServices.js";
// import Credentials, { currentTenant, transactionFrom, userid } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import storeIcon from "../images/Icons/shop.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css"; // Import the shared CSS file

// const ProductionMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Production")
//   }, [])

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>
      
//       <Header />
//       <Menu />
      
//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <nav className="menu-breadcrumb">
//                 <Link
//                   to="/index"
//                   className="menu-breadcrumb-link"
//                   onMouseEnter={() => setHovered('home')}
//                   onMouseLeave={() => setHovered(null)}
//                 >
//                   Home
//                 </Link>
//                 <span>/</span>
//                 <span className="menu-breadcrumb-active">
//                   Production
//                 </span>
//               </nav>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>
                
//                 <div className="menu-sections-container">
//                   {(screens.includes("Estimation") || screens.includes("Job Order") || screens.includes("Indenting") || screens.includes("InProcess") || screens.includes("Quality Analysis") || screens.includes("Immediate Production")) ? (
//                     <div className="menu-section menu-transactions-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                         <span className="menu-section-title-text">Transactions</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/productiontemplates" }}
//                             state={{ message: "" }}
//                           >
//                             Production Template
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/immediateproduction" }}
//                             state={{ message: "" }}
//                           >
//                             Immediate Production
//                           </Link>
//                         </li>
//                         {screens.includes("Estimation") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/estimation" }}
//                               state={{ message: "" }}
//                             >
//                               Estimation
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Job Order") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/joborder" }}
//                               state={{ message: "" }}
//                             >
//                               Job Order
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Indenting") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/indenting" }}
//                               state={{ message: "" }}
//                             >
//                               Indenting
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("InProcess") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/inprocess" }}
//                               state={{ message: "" }}
//                             >
//                               InProcess
//                             </Link>
//                           </li>
//                         ) : ""}
//                         {screens.includes("Quality Analysis") ? (
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/qa" }}
//                               state={{ message: "" }}
//                             >
//                               Quality Analysis
//                             </Link>
//                           </li>
//                         ) : ""}
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {screens.includes("Store") ? (
//                     <div className="menu-section-store">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={storeIcon} />
//                         <span className="menu-section-title-text">Store</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/store" }}
//                             state={{ message: "" }}
//                           >
//                             Store
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-reports" src={reportsIcon} />
//                       <span className="menu-section-title-text">Reports</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/productionreports" }}
//                           state={{ message: "" }}
//                         >
//                           Production Report
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/productionprocessreports" }}
//                           state={{ message: "" }}
//                         >
//                           Process Report
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/productiontransactionreports" }}
//                           state={{ message: "" }}
//                         >
//                           Stock Transaction Report
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(ProductionMenu);








import React from 'react';
import { 
  FolderLock, 
  ArrowRightLeft, 
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  Factory,
  Sparkles,
  Calendar,
  Activity,
  CheckCircle2,
  LayoutTemplate,
  FastForwardIcon
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const ProductionMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
     {
      title: 'Transactions',
      subtitle: 'Industrial production shop floor runs',
      icon: Layers,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-100 tw-text-emerald-600 tw-border-emerald-200',
      items: [
        { id: 'prodtemp', label: 'Production Template', desc: 'Industrial process Bill of Materials (BOM)', icon: LayoutTemplate, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-707', path: '/productiontemplates', brandColor: theme==='classic' ? '#4d4d4d' : '#6366F1' },
        { id: 'immprod', label: 'Immediate Production', desc: 'Direct batch ledger processing', icon: FastForwardIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707 tw-animate-pulse', path: '/immediateproduction', brandColor: theme==='classic' ? '#4d4d4d' : '#F59E0B' },
        { id: 'prodest', label: 'Estimation', desc: 'Raw material forecasting and weightings', icon: Calculator, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/estimation', brandColor: theme==='classic' ? '#4d4d4d' : '#10B981' },
        { id: 'jobord', label: 'Job Order', desc: 'Factory workshop scheduler queues', icon: Calendar, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700', path: '/joborder', brandColor: theme==='classic' ? '#4d4d4d' : '#F43F5E' },
        { id: 'prodind', label: 'Indenting', desc: 'Raw material demand notifications', icon: ClipboardCopy, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-cyan-50 hover:tw-bg-cyan-100 tw-text-cyan-700', path: '/indenting', brandColor: theme==='classic' ? '#4d4d4d' : '#06B6D4' },
        { id: 'inproc', label: 'InProcess', desc: 'Assembly status pipeline dashboards', icon: Activity, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/inprocess', brandColor: theme==='classic' ? '#4d4d4d' : '#3B82F6' },
        { id: 'qa', label: 'Quality Analysis', desc: 'Industrial parameters tolerance checks', icon: CheckCircle2, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 tw-text-teal-700', path: '/qa', brandColor: theme==='classic' ? '#4d4d4d' : '#14B8A6' }
      ]
    },
    {
      title: 'Store',
      subtitle: 'Warehouse raw material silos',
      icon: Warehouse,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-100 tw-text-blue-600 tw-border-blue-200',
      items: [
        { id: 'prodstore', label: 'Store', desc: 'Raw material silo registers & capacities', icon: Warehouse, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/store', brandColor: theme==='classic' ? '#4d4d4d' : '#6366F1' }
      ]
    },
    {
      title: 'Reports',
      subtitle: 'Manufacturing analytics & stats',
      icon: FileText,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-100 tw-text-emerald-600 tw-border-emerald-200',
      items: [
        { id: 'rpt_prod', label: 'Production Report', desc: 'Historical shift-wise outputs', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/productionreports', brandColor: theme==='classic' ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_process', label: 'Process Report', desc: 'Unit cycling times and lag sheets', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/productionprocessreports', brandColor: theme==='classic' ? '#4d4d4d' : '#10B981' },
        { id: 'rpt_stock_tx', label: 'Stock Transaction Report', desc: 'Aggregated silo input-output indices', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-700', path: '/productiontransactionreports', brandColor: theme==='classic' ? '#4d4d4d' : '#10B981' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path);
  }

  return (
        <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>
         <Layout menu={"production"}>
         <div className="menu-container tw-mr-2 tw-ml-4">
          <div
  id="dashboard-content-area"
  className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
>
  {/* Upper Hero Grid */}
  <div
    id="hero-welcome-banner"
    className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
  >
    {/* Background Blur Shapes */}
    <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

    {/* Left Content */}
    <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
      <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Production Management",path:null}]}/>
      <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
        Production Management
      </h1>

      <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
      Monitor workshop schedules, program automatic raw material bill configurations, configure silo allocations, and execute quality inspections.
      </p>
    </div>

     {/* 3D SVG Security Badging Illustration */}
        <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
          {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
          <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center">

            <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>
              <Factory size={75} className="tw-text-indigo-500 tw-drop-shadow-lg tw-animate-spin-slow" />
           {/* <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl">
              <defs>
                <linearGradient id="facGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#818CF8" />
                  <stop offset="100%" stopColor="#4F46E5" />
                </linearGradient>
                <linearGradient id="gearGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#475569" />
                  <stop offset="100%" stopColor="#0F172A" />
                </linearGradient>
              </defs>
              <rect x="25" y="60" width="150" height="90" rx="12" fill="url(#facGrad)" />
              <rect x="50" y="30" width="16" height="40" fill="#312E81" />
              <rect x="80" y="25" width="16" height="45" fill="#312E81" />
              <circle cx="100" cy="105" r="28" fill="url(#gearGrad)" className="animate-spin" style={{ animationDuration: '10s' }} />
              <circle cx="100" cy="105" r="14" fill="#818CF8" />
              <path d="M100 72 L100 138" stroke="url(#gearGrad)" strokeWidth="10" strokeLinecap="round" className="animate-spin" style={{ animationDuration: '10s' }} />
              <path d="M67 105 L133 105" stroke="url(#gearGrad)" strokeWidth="10" strokeLinecap="round" className="animate-spin" style={{ animationDuration: '10s' }} />
            </svg> */}
          </div>
        </div>
  </div>

  {/* Main Grid */}
  <div
    id="erp-columns-grid"
    className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
  >


    {/* Menus */}
        {newsections.map((section) => {
          // const Icon = section.icon;
          return(
     <div
            key={section.title}
      id="section-col-masters"
      className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
    >
      <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
        <div
          className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
        >
          <FolderLock size={22} />
          {/* <Icon size={22} color={section.iconColor} /> */}
        </div>

        <div>
          <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
            {section.title}
          </h2>

          <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
            {section.subtitle}
          </p>
        </div>
      </div>

      <div className="tw-space-y-3 tw-flex-1">
        {section.items.map((item) => {
          const Icon = item.icon;

          return (
            <button
              id={`subsection-btn-${item.id}`}
              key={item.id}
              onClick={() => onSelectItem(item.path)}
              className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
            >
              <div className="tw-flex tw-items-center tw-gap-3.5">
                <div
                  className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                >
                  <Icon size={16} color={item.brandColor} />
                </div>

                <div>
                  <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                    {item.label}
                  </h4>

                  {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                </div>
              </div>

              <ChevronRight
                size={16}
                className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
              />
            </button>
          );
        })}
      </div>
    </div>)}
  )}
  </div>

</div>
          </div>
          </Layout>
      </div>
  );
}
export default withRouter(ProductionMenu);